/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Stack,
  TableBody,
  Divider,
  Box,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import TextInput from "../../../form-fields/text-input";
import SelectInput from "../../../form-fields/select-input";
import DashBoardContainer from "../../../layout/dashboard-container";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import { useSelector } from "react-redux";
import { labels } from "../../../../lang/labels";
import { useFormik, FormikProvider, Form } from "formik";
import {
  getEDCTxnStatusSchema,
  getStampStockSchema,
  reprintReceiptValidationSchema,
} from "../../../../utils/validation-schema";
import { getReceiptList } from "../../../../services/generate-counter-receipt";
import { useNavigate } from "react-router-dom";
import { ArrowBack, Print } from "@mui/icons-material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import FormButtons from "../buttons";
import DateInput from "../../../form-fields/date-picker";
import { useReactToPrint } from "react-to-print";
import { getStampStockReport } from "../../../../services/stamp-service";
import useApi from "../../../common/useApiHook";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import { getUserZoneList } from "../../../../services/coinage-challan-service";
import { getCurrentDate, getErrorMsg } from "../../../../utils/helpers";
import ScrollTop from "../../../common/scrollTop";
import { showToastError } from "../../../common/toastHelper";
import "./revenue-stamp-report.css";

const RevenueStampReport = () => {
  const navigate = useNavigate();
  const printRef = useRef();

  const initialState = {
    zoneName: "",
    fromDate: getCurrentDate(),
    toDate: getCurrentDate(),
    counter: "",
  };
  const lang = useSelector((state) => state.userDetails.lang);
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: getStampStockSchema,
  });

  const [reportData, setReportData] = useState("");

  const { loading, error, callApi, setError } = useApi(getStampStockReport);
  // eslint-disable-next-line no-unused-vars
  const [counterList, setCounterList] = useState([
    { value: 1, label: "1" },
    { value: 2, label: "2" },
  ]);
  const [zones, setZoneList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const zoneListRes = await getUserZoneList();
        const zoneList = zoneListRes.map((record) => ({
          value: record.zonename,
          label: record.zonename,
        }));
        setZoneList(zoneList);
      } catch (error) {
        showToastError(getErrorMsg(error));
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures it runs only once

  const handleSubmitButtonClick = async (e) => {
    e.preventDefault();
    const response = await callApi(formik.values);
    setReportData(response);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  return (
    <DashBoardContainer>
      {loading && <Loader />}
      {error && (
        <AlertMsg
          severity="error"
          onClose={() => {
            setError("");
          }}
        />
      )}
      <FormikProvider value={formik}>
        <Form>
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title={labels.revenueStampReport[lang]} />
            <Grid>
              <GridRow>
                <FormLabel label={labels.Zone[lang]} required />
                <FormValue
                  component={
                    <SelectInput name="zoneName" options={zones} required />
                  }
                />
                <FormLabel label={labels.Counter[lang]} required />
                <FormValue
                  component={
                    <SelectInput
                      name="counter"
                      options={counterList}
                      required
                    />
                  }
                />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.FromDate[lang]} required />
                <FormValue component={<DateInput name="fromDate" required />} />
                <FormLabel label={labels.ToDate[lang]} required />
                <FormValue component={<DateInput name="toDate" required />} />
              </GridRow>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    isValid={!(formik.isValid && formik.dirty)}
                    handleSubmitButtonClick={handleSubmitButtonClick}
                    resetForm={() => {
                      formik.resetForm();
                      setError("");
                      setReportData("");
                    }}
                    submitBtnLabel="Show"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Form>

        {reportData.lstStamp && reportData.lstStamp.length ? (
          <>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                sx={{ margin: 2 }}
                onClick={handlePrint}
                variant="contained"
                startIcon={<Print />}
              >
                Print
              </Button>
            </Box>
            <Grid ref={printRef}>
              <Grid container justifyContent="center">
                <Grid
                  sx={{
                    textAlign: "center", // Centers the text horizontally
                    fontWeight: "bold", // Ensures the text is bold
                  }}
                >
                  <b>
                    पिंपरी चिंचवड महानगरपालिका,पिंपरी - ४११०१८
                    <br />
                    लेखा विभाग
                    <br />
                    दैनंदिन रेव्हेन्यू स्टॅम्प रजिस्टर
                  </b>
                </Grid>
              </Grid>

              
              <Grid
                container
                spacing={2}
                sx={{ width: "85%", marginLeft: "110px" }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <div>
                    {labels.Zone[lang]} - {reportData.zoneName}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <div>
                    {labels.Counter[lang]} - {reportData.counter}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <div>
                    पासून - {reportData.fromDate} ते {reportData.toDate}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <div>
                    {labels.receiveDate[lang]} - {reportData.receiveDate}
                  </div>
                </Grid>
              </Grid>
              <br />
              <Divider />
              <GridRow>
                <TableContainer style={{ padding: "50px" }}>
                  <Table
                    size="small"
                    sx={{ minWidth: 400 }}
                    aria-label="simple table"
                    style={{ width: "100%" }} // Ensure the table takes full width
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          background: "#e6eaeb",
                          "&:last-child td, &:last-child th": {
                            border: "1px solid black",
                          },
                        }}
                      >
                        <TableCell align="center">
                          {labels.SrNo[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptDate[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.noOfStamps[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.costOfStamp[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.PaymentMode[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptNumber[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptAmount[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.ReceiptStatus[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.remainingStamps[lang]}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reportData.lstStamp.map((item, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell align="center" className="cellBorder">
                              {index + 1}
                            </TableCell>
                            <TableCell align="center" className="cellBorder">
                              {item.receiveDate}
                            </TableCell>
                            <TableCell align="center" className="cellBorder">
                              {item.noOfStamp}
                            </TableCell>
                            <TableCell align="center" className="cellBorder">
                              {item.costPerStamp}
                            </TableCell>
                            <TableCell align="center" className="cellBorder">
                              {item.modeofPayment}
                            </TableCell>
                            <TableCell align="center" className="cellBorder">
                              {item.receiptno}
                            </TableCell>
                            <TableCell align="center" className="cellBorder">
                              {item.receiptCost}
                            </TableCell>
                            <TableCell align="center" className="cellBorder">
                              {item.status}
                            </TableCell>
                            <TableCell align="center" className="cellBorder">
                              {item.remaingStamp}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </GridRow>
            </Grid>
          </>
        ) : (
          <></>
        )}
      </FormikProvider>
      <ScrollTop />
    </DashBoardContainer>
  );
};
export default RevenueStampReport;
